import * as serviceContext from './serviceContext';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getClientSettlement() {
    try {
        const response = await serviceContext.get("account/settlement/client", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getMasterSettlement() {
    try {
        const response = await serviceContext.get("account/settlement/master", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postClientSettlement(data) {

    try {
        const response = await serviceContext.post("account/settlement/client", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postMasterSettlement(data) {

    try {
        const response = await serviceContext.post("account/settlement/master", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};